import React from "react";

class AboutSection extends React.Component {
  render () {
    return (
      <div className="main">
        <div className="row">
          <div className="col-md-12">
            <div style={{ marginTop: "15px" }} className="datahub-description">
              <p>The GWI tariff database includes detailed breakdowns of water, wastewater, and stormwater tariffs from 2011-2025 for 600+ cities worldwide. Explore yearly changes to tariff prices, structure, and cost per m³ for every location in the survey.</p>
              <p>This dataset includes information about domestic water, wastewater, and stormwater tariffs in 641 cities. This data represents the combined water and wastewater bill for a household of four people using 15m3 of water a month living in a house with 200 m² of impervious area. The data is representative of the tariffs on 1<sup>st</sup> July of each year.</p>
              <p>The data was collected in local currency and was converted to US dollars using the exchange rate on 1st July 2025. This allows the tariffs to be compared in US dollars without the effect of exchange rate fluctuations.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AboutSection.propTypes = {
};

export default AboutSection;
